import React, { useState } from 'react';

import Button from '@navi/web-ui/lib/primitives/Button/index';
import ViewFeedbackForm from './ViewFeedbackForm';
import { FieldFeedbackActionBtnProps } from '../interfaces/index.type';
import styles from '../index.module.scss';
import { FIELD_FEEBACK_TYPES } from '../constants';

const FieldFeedbackAction: React.FC<FieldFeedbackActionBtnProps> = props => {
  const { answerViews, comments, gMapLocationUrl } = props;
  const [showModal, setShowModal] = useState(false);
  const feedbackExists: boolean = answerViews?.length > 0;

  const toggleModal = () => setShowModal(!showModal);

  return (
    <>
      {feedbackExists && (
        <div className={styles.actionWrapper}>
          <Button
            onClick={() => {
              toggleModal();
            }}
            variant="text"
          >
            {FIELD_FEEBACK_TYPES.VIEW}
          </Button>
        </div>
      )}
      {showModal && (
        <ViewFeedbackForm
          open={showModal}
          modalType={FIELD_FEEBACK_TYPES.FIELD_FEEDBACK}
          onClose={toggleModal}
          answers={answerViews}
          comments={comments}
          gMapLocationUrl={gMapLocationUrl}
        />
      )}
    </>
  );
};

export default FieldFeedbackAction;
